var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 482 507.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff060a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tron-trx") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tron"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M475.44,152.78C451.67,130.83,418.79,97.31,392,73.54l-1.58-1.11a30.33,30.33,0,0,0-8.8-4.91h0C317,55.48,16.48-.71,10.62,0A11.07,11.07,0,0,0,6,1.75L4.52,2.94A17.51,17.51,0,0,0,.4,9.59l-.4,1v6.5C33.84,111.34,167.44,420,193.74,492.41c1.59,4.91,4.6,14.26,10.23,14.74h1.26c3,0,15.85-17,15.85-17S450.56,211.9,473.78,182.26a74.25,74.25,0,0,0,7.92-11.73A19.1,19.1,0,0,0,475.44,152.78ZM280,185.19,377.9,104l57.45,52.93Zm-38-5.31L73.3,41.69,346.12,92Zm15.22,36.22,172.58-27.82L232.41,426ZM50.4,55.48,227.82,206,202.14,426.16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTron);
export default __webpack_public_path__ + "static/media/tron.4ebcf8af5195c6137a567ea13876a6a6.svg";
export { ForwardRef as ReactComponent };